import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  onClick?: () => void;
  glow?: boolean;
  variant?: 'default' | 'glass' | 'elevated';
}
const paddingStyles = {
  none: '',
  sm: 'p-4',
  md: 'p-5',
  lg: 'p-7'
};
export function Card({
  children,
  className = '',
  padding = 'md',
  onClick,
  glow = false,
  variant = 'default'
}: CardProps) {
  const base = 'relative rounded-2xl transition-all duration-300 ease-out overflow-hidden';
  const variants = {
    default: 'bg-white dark:bg-[#111827] border border-gray-100 dark:border-white/[0.06] shadow-sm dark:shadow-none',
    glass: 'bg-white/70 dark:bg-white/[0.04] backdrop-blur-xl border border-white/60 dark:border-white/[0.08] shadow-sm',
    elevated: 'bg-white dark:bg-[#141B2D] border border-gray-100 dark:border-white/[0.05] shadow-lg dark:shadow-2xl dark:shadow-black/40'
  };
  const interactive = onClick ? 'cursor-pointer hover:scale-[1.012] hover:shadow-md dark:hover:border-white/[0.12] active:scale-[0.998]' : '';
  const glowClass = glow ? 'ring-1 ring-cyan-500/20 dark:ring-cyan-400/10' : '';
  return <div className={`${base} ${variants[variant]} ${interactive} ${glowClass} ${paddingStyles[padding]} ${className}`} onClick={onClick} data-id="element-6362" data-mp="2up1w0er4nl1k">
      
      {children}
    </div>;
}
interface CardHeaderProps {
  children: React.ReactNode;
  className?: string;
}
export function CardHeader({
  children,
  className = ''
}: CardHeaderProps) {
  return <div className={`pb-4 border-b border-gray-100 dark:border-white/[0.06] ${className}`} data-id="element-6363" data-mp="3dh46t9h3873w">
      {children}
    </div>;
}
interface CardTitleProps {
  children: React.ReactNode;
  className?: string;
}
export function CardTitle({
  children,
  className = ''
}: CardTitleProps) {
  return <h3 className={`text-base font-semibold text-gray-900 dark:text-white tracking-tight ${className}`} data-id="element-6364" data-mp="1x2mfbf6iyrf2">
      {children}
    </h3>;
}
interface CardContentProps {
  children: React.ReactNode;
  className?: string;
}
export function CardContent({
  children,
  className = ''
}: CardContentProps) {
  return <div className={`pt-4 ${className}`} data-id="element-6365" data-mp="1zh9d62nu53iu">{children}</div>;
}